module.exports = __webpack_public_path__ + "img/wall.2b0c9c32.png";